import { render, staticRenderFns } from "./projectDocumentTypesList.vue?vue&type=template&id=46123012&scoped=true&"
import script from "./projectDocumentTypesList.vue?vue&type=script&lang=js&"
export * from "./projectDocumentTypesList.vue?vue&type=script&lang=js&"
import style0 from "./projectDocumentTypesList.vue?vue&type=style&index=0&id=46123012&lang=scss&scoped=true&"
import style1 from "./projectDocumentTypesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46123012",
  null
  
)

export default component.exports